import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ConstantMan } from './constantMan';
import { User } from 'anchor-shared/lib/model/entity/user';
import * as moment from 'moment';
import { VesselImage } from 'anchor-shared/lib/model/entity/vesselImage';

@Injectable()
export class EnvironmentalMediaService {
  envName: string;
  clientBase: string;
  private readonly stripeStartOauthFlowBase: string;
  redirectUri: string;
  stripeClientId: string;
  stripePublishableKey: string;

  constructor() {
    switch (environment.envName) {
      case 'local':
        this.envName = ConstantMan.MEDIA_ENV_NAMES.LOCAL;
        this.clientBase = ConstantMan.CLIENT.BASE.LOCAL;
        this.redirectUri = ConstantMan.STRIPE_REDIRECTS.LOCAL;
        this.stripeClientId = 'ca_MJlaNQpp7PkYU6349CZTq2d1R0iBJ2RK';
        this.stripePublishableKey =
          'pk_test_51LNIWQJbjxUN0uMzJBlRgNhPJdfXpquOIa1PJNWNgr5PHvOaf4dftS95QNUSpr2AhIREp1tk1MfQi8XDfUkgSXTs00DjaiXP89';
        break;
      case 'local-like-production':
        this.envName = ConstantMan.MEDIA_ENV_NAMES.LOCAL;
        this.clientBase = ConstantMan.CLIENT.BASE.LOCAL;
        this.redirectUri = ConstantMan.STRIPE_REDIRECTS.LOCAL;
        this.stripeClientId = 'ca_MJlaNQpp7PkYU6349CZTq2d1R0iBJ2RK';
        this.stripePublishableKey =
          'pk_test_51LNIWQJbjxUN0uMzJBlRgNhPJdfXpquOIa1PJNWNgr5PHvOaf4dftS95QNUSpr2AhIREp1tk1MfQi8XDfUkgSXTs00DjaiXP89';
        break;
      case 'dev':
        this.envName = ConstantMan.MEDIA_ENV_NAMES.ALPHA;
        this.clientBase = ConstantMan.CLIENT.BASE.DEV;
        this.redirectUri = ConstantMan.STRIPE_REDIRECTS.DEV;
        this.stripeClientId = 'ca_MJlaNQpp7PkYU6349CZTq2d1R0iBJ2RK';
        this.stripePublishableKey =
          'pk_test_51LNIWQJbjxUN0uMzJBlRgNhPJdfXpquOIa1PJNWNgr5PHvOaf4dftS95QNUSpr2AhIREp1tk1MfQi8XDfUkgSXTs00DjaiXP89';
        break;
      case 'stage':
        this.envName = ConstantMan.MEDIA_ENV_NAMES.BETA;
        this.clientBase = ConstantMan.CLIENT.BASE.STAGE;
        this.redirectUri = ConstantMan.STRIPE_REDIRECTS.STAGE;
        this.stripeClientId = 'ca_MJlaNQpp7PkYU6349CZTq2d1R0iBJ2RK';
        this.stripePublishableKey =
          'pk_test_51LNIWQJbjxUN0uMzJBlRgNhPJdfXpquOIa1PJNWNgr5PHvOaf4dftS95QNUSpr2AhIREp1tk1MfQi8XDfUkgSXTs00DjaiXP89';
        break;
      case 'prod':
        this.envName = ConstantMan.MEDIA_ENV_NAMES.PROD;
        this.clientBase = ConstantMan.CLIENT.BASE.PROD;
        this.redirectUri = ConstantMan.STRIPE_REDIRECTS.PROD;
        this.stripeClientId = 'ca_MJlaLHuEI4hmiLh0LMF7ZRHRYHTN80Xv';
        this.stripePublishableKey =
          'pk_live_51LNIWQJbjxUN0uMzBUHf7XR4j1urDYSCEYUtKHbPUz7I5lZcI2Q91SZiE0qq99XoESNkay6JLH1IxVzSYyEJbccT00aljOQaHR';
        break;
      default:
        this.envName = ConstantMan.MEDIA_ENV_NAMES.LOCAL;
        this.clientBase = ConstantMan.CLIENT.BASE.LOCAL;
        this.redirectUri = ConstantMan.STRIPE_REDIRECTS.LOCAL;
        this.stripeClientId = 'ca_MJlaNQpp7PkYU6349CZTq2d1R0iBJ2RK';
        this.stripePublishableKey =
          'pk_test_51LNIWQJbjxUN0uMzJBlRgNhPJdfXpquOIa1PJNWNgr5PHvOaf4dftS95QNUSpr2AhIREp1tk1MfQi8XDfUkgSXTs00DjaiXP89';
        break;
    }
    this.stripeStartOauthFlowBase =
      'https://connect.stripe.com/express/oauth/authorize?response_type=code&scope=read_write';
  }

  public buildEnvironmentSpecificUrl(fileName: string): string {
    return (
      ConstantMan.ENVIRONMENTAL_MEDIA_CONFIG.BASE +
      this.envName +
      '/' +
      fileName
    );
  }

  public buildVesselImageURL(vesselImageURL: string): string {
    if (
      !vesselImageURL ||
      vesselImageURL.includes('.thumb') ||
      !vesselImageURL.includes('/vessel-images/')
    ) {
      return vesselImageURL;
    }
    let resourceKey = vesselImageURL.split('.com')[1];
    if (vesselImageURL.includes('anchor-rides-alpha')) {
      return `https://d3uwoa8fht7qft.cloudfront.net${resourceKey}?format=webp&bucket=anchor-rides-alpha`;
    } else if (vesselImageURL.includes('anchor-rides-beta')) {
      return `https://d3uwoa8fht7qft.cloudfront.net${resourceKey}?format=webp&bucket=anchor-rides-beta`;
    } else if (vesselImageURL.includes('anchor-rides')) {
      return `https://d3uwoa8fht7qft.cloudfront.net${resourceKey}?format=webp&bucket=anchor-rides`;
    } else {
      return vesselImageURL;
    }
  }

  public getStripeStartOathBase(): string {
    return this.stripeStartOauthFlowBase;
  }

  public buildStripeRedirect(route: string): string {
    return this.redirectUri + route;
  }

  public getStripeClientId(): string {
    return this.stripeClientId;
  }

  public appendQueryPair(
    stringUrl: string,
    key: string,
    value: string,
  ): string {
    return stringUrl + '&' + key + '=' + value;
  }

  public getClientBaseURL(): string {
    return this.clientBase;
  }

  public getStripePublishableKey(): string {
    return this.stripePublishableKey;
  }

  public addUserDataToStripeUrl(stringUrl: string, user: User): string {
    let newDataUrl: string = stringUrl;
    newDataUrl = this.appendQueryPair(newDataUrl, 'stripe_user[country]', 'US');
    newDataUrl = this.appendQueryPair(
      newDataUrl,
      'stripe_user[url]',
      'https://www.anchorrides.com/',
    );
    newDataUrl = this.appendQueryPair(
      newDataUrl,
      'stripe_user[email]',
      user.email,
    );
    newDataUrl = this.appendQueryPair(
      newDataUrl,
      'stripe_user[first_name]',
      user.firstName,
    );
    newDataUrl = this.appendQueryPair(
      newDataUrl,
      'stripe_user[last_name]',
      user.lastName,
    );
    if (user.phoneNumber) {
      newDataUrl = this.appendQueryPair(
        newDataUrl,
        'stripe_user[phone_number]',
        user.phoneNumber.replace(/[^+\d]+/g, ''),
      );
    }
    if (user.birthday) {
      let userBirthday = moment(user.birthday, 'YYYY/MM/DD');
      newDataUrl = this.appendQueryPair(
        newDataUrl,
        'stripe_user[dob_day]',
        userBirthday.format('D'),
      );
      newDataUrl = this.appendQueryPair(
        newDataUrl,
        'stripe_user[dob_month]',
        userBirthday.format('M'),
      );
      newDataUrl = this.appendQueryPair(
        newDataUrl,
        'stripe_user[dob_year]',
        userBirthday.format('YYYY'),
      );
    }
    if (user.street) {
      newDataUrl = this.appendQueryPair(
        newDataUrl,
        'stripe_user[street_address]',
        user.street,
      );
    }
    if (user.city) {
      newDataUrl = this.appendQueryPair(
        newDataUrl,
        'stripe_user[city]',
        user.city,
      );
    }
    if (user.state) {
      newDataUrl = this.appendQueryPair(
        newDataUrl,
        'stripe_user[state]',
        user.state,
      );
    }
    if (user.zip) {
      newDataUrl = this.appendQueryPair(
        newDataUrl,
        'stripe_user[zip]',
        `${user.zip}`,
      );
    }
    return newDataUrl;
  }
}
